import Link from "@src/app/components/Link";
import { createMetaTags } from "@src/app/components/MetaTags/MetaTags";

const linkList = [
  {
    name: "网站使用条例",
    path: "https://www.sph.com.sg/tnc/website",
  },
  {
    name: "隐私权政策",
    path: "https://www.sph.com.sg/tnc/privacy",
  },
  {
    name: "个人资料保护声明",
    path: "https://www.sph.com.sg/tnc/pdpa",
  },
  {
    name: "Cookie政策",
    path: "https://www.sph.com.sg/tnc/cookie",
  },
];

export const meta = () =>
  createMetaTags({
    title: "版权声明 | 红蚂蚁",
    description:
      "版权声明 - 《红蚂蚁》以生动的笔调撰写独立观点，以新颖的手法呈现新闻，让读者被咬得直呼过瘾。",
    canonical: "https://www.redants.sg/copyright",
  });

export default function CopyrightPage() {
  return (
    <main className="box-border bg-secondary py-[20px] lg:px-[24px]">
      <div className="m-auto box-border px-[12px] text-secondary xs:max-w-full xs:py-0 lg:min-h-[calc(100vh-286px)] lg:max-w-[944px] lg:py-[16px] xxl:max-w-[800px]">
        <h1 className="mb-[12px] text-header-1">版权与隐私声明</h1>
        <p className="mb-[16px] text-body-1">
          Red Anthill Ventures Pte. Ltd. 版权所有（公司登记号：201712622N）
        </p>
        <p className="mb-[16px] text-body-1">
          网络业者若未经许可，擅自引用本网站的内容将面对法律行动。
        </p>
        <p className="mb-[16px] text-body-1">
          第三方公司可能在红蚂蚁网站宣传他们的产品或服务。不过您跟第三方公司的任何交易与红蚂蚁网站无关，红蚂蚁网站将不会对可能引起的任何损失负责。
        </p>
        <p className="mb-[24px] text-body-1">
          以下链接为本网站使用条例（Website Terms &
          Conditions）、隐私权政策（Privacy
          Policy）以及个人资料保护声明（PDPA）。
        </p>
        {linkList.map((link) => (
          <div key={link.name} className="mb-[12px]">
            <Link
              to={link.path}
              className="cursor-pointer text-body-1 text-link-primary underline"
            >
              <span className="hover:text-link-primary-hover">{link.name}</span>
            </Link>
          </div>
        ))}
      </div>
    </main>
  );
}
